/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignInRequest } from '../../models/sign-in-request';
import { SignInResponse } from '../../models/sign-in-response';

export interface AuthSignIn$Plain$Params {
      body: SignInRequest
}

export function authSignIn$Plain(http: HttpClient, rootUrl: string, params: AuthSignIn$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponse>> {
  const rb = new RequestBuilder(rootUrl, authSignIn$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInResponse>;
    })
  );
}

authSignIn$Plain.PATH = '/api/v1/auth/sign-in';
